/**
 * @license
 * Copyright (c) 2021 Handsoncode. All rights reserved.
 */
export class MatrixMapping {
    constructor() {
        this.matrixMapping = new Map();
    }
    getMatrix(range) {
        return this.matrixMapping.get(range.toString());
    }
    setMatrix(range, vertex) {
        this.matrixMapping.set(range.toString(), vertex);
    }
    removeMatrix(range) {
        this.matrixMapping.delete(range.toString());
    }
    isFormulaMatrixInRow(sheet, row) {
        for (const mtx of this.matrixMapping.values()) {
            if (mtx.spansThroughSheetRows(sheet, row) && mtx.isFormula()) {
                return true;
            }
        }
        return false;
    }
    isFormulaMatrixInRows(span) {
        for (const row of span.rows()) {
            if (this.isFormulaMatrixInRow(span.sheet, row)) {
                return true;
            }
        }
        return false;
    }
    isFormulaMatrixInColumn(sheet, column) {
        for (const mtx of this.matrixMapping.values()) {
            if (mtx.spansThroughSheetColumn(sheet, column) && mtx.isFormula()) {
                return true;
            }
        }
        return false;
    }
    isFormulaMatrixInColumns(span) {
        for (const col of span.columns()) {
            if (this.isFormulaMatrixInColumn(span.sheet, col)) {
                return true;
            }
        }
        return false;
    }
    isFormulaMatrixInRange(range) {
        for (const mtx of this.matrixMapping.values()) {
            if (mtx.isFormula() && mtx.getRange().doesOverlap(range)) {
                return true;
            }
        }
        return false;
    }
    isFormulaMatrixAtAddress(address) {
        for (const mtx of this.matrixMapping.values()) {
            if (mtx.getRange().addressInRange(address) && mtx.isFormula()) {
                return true;
            }
        }
        return false;
    }
    *numericMatrices() {
        for (const [mtxKey, mtx] of this.matrixMapping.entries()) {
            if (!mtx.isFormula()) {
                yield [mtxKey, mtx];
            }
        }
    }
    *numericMatricesInRows(rowsSpan) {
        for (const [mtxKey, mtx] of this.matrixMapping.entries()) {
            if (mtx.spansThroughSheetRows(rowsSpan.sheet, rowsSpan.rowStart, rowsSpan.rowEnd) && !mtx.isFormula()) {
                yield [mtxKey, mtx];
            }
        }
    }
    *numericMatricesInColumns(columnsSpan) {
        for (const [mtxKey, mtx] of this.matrixMapping.entries()) {
            if (mtx.spansThroughSheetColumn(columnsSpan.sheet, columnsSpan.columnStart, columnsSpan.columnEnd) && !mtx.isFormula()) {
                yield [mtxKey, mtx];
            }
        }
    }
    *numericMatricesInRange(range) {
        for (const [mtxKey, mtx] of this.matrixMapping.entries()) {
            if (mtx.getRange().doesOverlap(range)) {
                yield [mtxKey, mtx];
            }
        }
    }
    truncateMatricesByRows(rowsSpan) {
        const verticesToRemove = Array();
        for (const [key, matrix] of this.numericMatricesInRows(rowsSpan)) {
            matrix.removeRows(rowsSpan);
            if (matrix.height === 0) {
                this.removeMatrix(key);
                verticesToRemove.push(matrix);
            }
        }
        return verticesToRemove;
    }
    truncateMatricesByColumns(columnsSpan) {
        const verticesToRemove = Array();
        for (const [key, matrix] of this.numericMatricesInColumns(columnsSpan)) {
            matrix.removeColumns(columnsSpan);
            if (matrix.width === 0) {
                this.removeMatrix(key);
                verticesToRemove.push(matrix);
            }
        }
        return verticesToRemove;
    }
    destroy() {
        this.matrixMapping.clear();
    }
}
